// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 557 ? "f10664bc" : chunkId) + "." + {"212":"371e03fc10b09acb","505":"78af71967b35bf9e","557":"21b08f01028e7219"}[chunkId] + ".js";
};